import { LoginDetails } from '@/model/login-details';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  showPassword: boolean = false;
  loginDetails: LoginDetails;
  constructor(private appService: AppService, private toastr: ToastrService,
    private spinner: NgxSpinnerService, private router: Router,
  ) {
  }

  registrationForm = new UntypedFormGroup({
    userName: new UntypedFormControl('', [Validators.required]),
    phoneNumber: new UntypedFormControl('', [Validators.required, Validators.pattern(/^\d{10}$/)]),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    password: new UntypedFormControl('', [Validators.required, Validators.minLength(6)]),
    userType: new UntypedFormControl('USER', [Validators.required])
  });

  ngOnInit(): void {
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  onSubmit() {
    if (this.registrationForm.valid) {
      this.saveRegistrationDetails();
    } else {
      this.registrationForm.markAllAsTouched();
    }
  }

  get f() {
    return this.registrationForm.controls;
  }

  saveRegistrationDetails() {
    this.spinner.show();
    this.appService.registrationSave(this.registrationForm.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.spinner.hide();
        this.toastr.success('Registration Successful');
        this.loginDetails = data;
        localStorage.setItem('authToken', this.loginDetails.authHeader);
        localStorage.setItem('userType', this.loginDetails.regDetails.userType);
        localStorage.setItem('userId', String(this.loginDetails.regDetails.userRegistrationId));
        this.router.navigate(['/main/add-certificate']);
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.message || "Something Went Wrong,Please Try Again...")
      })
  }
}
